import { t } from '@/i18n/i18ns'
import CountryFlag from 'vue-country-flag-next'
import { PageResponse } from '@/utils/communication'
import { asyncValidationRule, asyncFormValidation } from '@/element-ui/form-utils'
import SelectCity from '../select-city/select-city-tmpl'
import _ from 'lodash'

import {
  getStateName
} from '../plan-upgrade-common'

export const validateEmptyFields = (errorMessage) => {
  return asyncValidationRule(async (rule, value) => {
    if (!value || value.trim() === '') {
      return new Error(errorMessage)
    }
  })
}

export default {
  name: 'plan-upgrade-billing-details',
  components: {
    CountryFlag,
    SelectCity
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    billingDetails: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      model: {
        companyName: '',
        VAT: '',
        streetAndNumber: '',
        city: '',
        zip: '',
        firstName: '',
        lastName: '',
        email: ''
      },
      modelRules: {
        companyName: [
          { validator: validateEmptyFields(t('label.requiredCompanyName')), trigger: 'change' }
        ],
        streetAndNumber: [
          { validator: validateEmptyFields(t('label.requiredStreetAndNumber')), trigger: 'change' }
        ],
        zip: [
          { validator: validateEmptyFields(t('label.requiredZipOrPostalCode')), trigger: 'change' }
        ],
        firstName: [
          { validator: validateEmptyFields(t('label.requiredFirstName')), trigger: 'change' }
        ],
        lastName: [
          { validator: validateEmptyFields(t('label.requiredLastName')), trigger: 'change' }
        ],
        email: [
          { validator: validateEmptyFields(t('label.requiredEmail')), trigger: 'change' }
        ],
        city: [
          { validator: validateEmptyFields(t('label.requiredCity')), trigger: 'change' }
        ]
      },
      handleer: {
        getStateName
      },
      countryCode: '',
      countryName: '',
      state: ''
    }
  },
  watch: {
    isActive: {
      immediate: true,
      handler (val) {
        if (val) {
          this.refreshForm()
          this.setCountryCode(this.billingDetails?.countryCode ?? '')
          this.setCountryName(this.billingDetails?.country ?? '')
          this.setState(this.billingDetails?.state ?? '')
        }
      }
    },
    billingDetails: {
      immediate: true,
      handler (newBillingDetails) {
        if (newBillingDetails) {
          this.refreshForm()
          this.setModelData(newBillingDetails)
          this.setCountryCode(this.billingDetails?.countryCode ?? '')
          this.setCountryName(this.billingDetails?.country ?? '')
          this.setState(this.billingDetails?.state ?? '')
        }
      }
    }
  },
  methods: {
    async getFormData () {
      return this.model
    },
    async submitForm (validateFn = asyncFormValidation) {
      const isFormValid = await validateFn(this.$refs.refFormBillingDetails)

      if (!isFormValid) {
        return PageResponse(true)
      }

      return PageResponse(false, this.nextPage, this.model)
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm')
      return false
    },
    refreshForm () {
      if (this.$refs.refFormBillingDetails) {
        this.$refs.refFormBillingDetails.clearValidate()
      }
    },
    setModelData (billingDetails) {
      if (_.isEmpty(billingDetails)) {
        return
      }

      this.model.VAT = billingDetails?.VAT ?? ''
      this.model.companyName = billingDetails?.companyName ?? ''
      this.model.streetAndNumber = billingDetails?.streetNumber ?? ''
      this.model.firstName = billingDetails?.firstName ?? ''
      this.model.lastName = billingDetails?.lastName ?? ''
      this.model.city = billingDetails?.city ?? ''
      this.model.email = billingDetails?.email ?? ''
      this.model.countryCode = billingDetails?.countryCode ?? ''
      this.model.zip = billingDetails?.zip ?? ''
      this.state = billingDetails?.state ?? ''
    },
    setCountryCode (countryCode) {
      this.countryCode = countryCode
    },
    setCountryName (countryName) {
      this.countryName = countryName
    },
    setState (state) {
      this.state = state
    },
    handleSelectCityChange ($event) {
      this.model.city = $event?.cityName ?? ''
    }
  },
  mounted () {}
}
